import * as yup from 'yup'

export const questionAnswerSchema = {
  id: yup.mixed().required(),
  value: yup.string().required(),
  name: yup.string(),
  subjectId: yup.mixed(),
  isEuropean: yup.number().nullable().notRequired(),
}

export default questionAnswerSchema
